import FileSaver from 'file-saver'

export default {
    install (Vue, options) {
        Vue.prototype.$fileSaver = FileSaver
    }
}

